
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import InvoiceFormFields from './InvoiceFormFields';
import InvoiceTypeSelector from './InvoiceTypeSelector';
import LineItemSelector from './LineItemSelector';
import InvoiceAmountPreview from './InvoiceAmountPreview';
import InvoiceFormActions from './InvoiceFormActions';

interface LineItem {
  id: string;
  description: string;
  manual_override: boolean;
  manual_total_cost: number | null;
  total_cost_snapshot: number;
}

interface InvoiceFormContentProps {
  form: UseFormReturn<any>;
  invoiceType: string;
  remainingBalance: number;
  lineItems: LineItem[] | null;
  selectedLineItems: string[];
  lineItemPercentages: { [key: string]: number };
  currentInvoiceAmount: number;
  remainingAfterInvoice: number;
  estimateId: string;
  isCreating: boolean;
  onSubmit: (values: any) => void;
  onLineItemSelection: (itemId: string, checked: boolean) => void;
  onLineItemPercentageChange: (itemId: string, percentage: number) => void;
  isEditMode?: boolean;
  invoiceId?: string;
}

const InvoiceFormContent: React.FC<InvoiceFormContentProps> = ({
  form,
  invoiceType,
  remainingBalance,
  lineItems,
  selectedLineItems,
  lineItemPercentages,
  currentInvoiceAmount,
  remainingAfterInvoice,
  estimateId,
  isCreating,
  onSubmit,
  onLineItemSelection,
  onLineItemPercentageChange,
  isEditMode = false,
  invoiceId
}) => {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <InvoiceFormFields form={form} />
        
        <InvoiceTypeSelector
          form={form}
          invoiceType={invoiceType}
          remainingBalance={remainingBalance}
        />

        {invoiceType === 'partial' && lineItems && (
          <LineItemSelector
            lineItems={lineItems}
            selectedLineItems={selectedLineItems}
            lineItemPercentages={lineItemPercentages}
            onSelectionChange={onLineItemSelection}
            onPercentageChange={onLineItemPercentageChange}
          />
        )}

        <InvoiceAmountPreview
          currentInvoiceAmount={currentInvoiceAmount}
          remainingAfterInvoice={remainingAfterInvoice}
          remainingBalance={remainingBalance}
        />

        <InvoiceFormActions
          estimateId={estimateId}
          isCreating={isCreating}
          isEditMode={isEditMode}
          invoiceId={invoiceId}
        />
      </form>
    </Form>
  );
};

export default InvoiceFormContent;
